import { useState, useEffect } from 'react';
import isMobile from 'ismobilejs';

export default function useIsIOSorIPAD() {
  const [isIOSorIPAD, setIsIOSorIPAD] = useState(false);

  useEffect(() => {
    if (typeof window !== 'undefined') {
      // Get the mobile detection info
      const mobileInfo = isMobile(window.navigator.userAgent);

      // Set iOS detection states
      setIsIOSorIPAD(mobileInfo.apple.phone || mobileInfo.apple.tablet);
    }
  }, []);

  return isIOSorIPAD;
}
